<template>
  <div>
    <!-- <slot>Set Header</slot> -->
    <nav class="navbar navbar-expand py-md-0 pt-0 pb-2 nav-top fixed-top nav-blue">
      <div class="collapse navbar-collapse">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item" v-for="item in navTop" :key="item.topTitle">
            <div class="d-flex">
                <a :class=" item.isMobile ? 'd-block d-sm-none' : '' " class="nav-link" :href="item.url" :target="item.openNewWeb ? '_blank' : '' ">{{ item.topTitle }}</a>
                <span class="p-1" style="color:#fff">|</span>
            </div>
          </li>
        </ul>
      </div>
    </nav>
  
  <header-menu v-on:valueToParent="childByValue"></header-menu>
</div>
</template>

<style scoped>
.nav-top{
  padding: 0 8rem;
}
.nav-logo {
    top: 0 !important ;
  }
@media (max-width: 1280px) {
  .nav-top{
    padding: 0 5rem;
  }
}
@media (max-width: 991px) {
  .nav-top{
    padding: 0 2rem;
  }
}
@media (max-width: 492px) {
  .nav-top{
    padding: 0 .5rem;
  }
  .navbar-expand .navbar-nav .nav-link {
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }
}

@media (max-width: 404px) {
  .navbar-expand .navbar-nav .nav-link {
    padding-left: 0;
    padding-right: 0;
    font-size: .85em;
  }
}
</style>

<script>
import HeaderMenu from './HeaderMenu'
export default {
  name: 'my-header',
  data () {  
    return {
      navTop: [],
      windowWidth: window.innerWidth,
    }
  },
  components: {
    HeaderMenu
  },
  methods:{
    childByValue:function(childValue) {            
      var _this = this
      var result = childValue === 'En' ? 
      [
        // { topTitle: 'Payment', url: 'http://pay.tac.com.tw/ebill/outer/loginForm', openNewWeb: true, isMobile: true },
        // { topTitle: 'Business Partner', url: 'https://www.tac-fg.com/Partner/Account/Login', openNewWeb: true },
        // { topTitle: 'Customer Services', url: 'https://customer.tac.com.tw/search_content_temp.php?menu=customer6',  openNewWeb: true }
      ] :
      [
        { topTitle: '我要繳款', url: 'https://www.tac.finance/Home/search_content', openNewWeb: false, isMobile: true },
        { topTitle: '合作夥伴', url: 'https://www.tac-fg.com/Partner/Account/Login', openNewWeb: true },
        { topTitle: '客戶服務', url: 'https://www.tac.finance/Home/search_content', openNewWeb: false }
      ]
      
      _this.$router.options.routes.filter(o => o.showClass === 'headerlink' && o.path.indexOf(childValue) > -1).forEach(o=>{
        result.push({
              topTitle : o.name,
              url : o.path,
              openNewWeb: false
          })
      })
      result.push((childValue === 'En' ? { topTitle: '中文', url: '/Tw',openNewWeb: false } : { topTitle: 'English', url: '/En',openNewWeb: false }))
      // result.push((childValue === 'En' ? { topTitle: '中文', url: '/Tw',openNewWeb: false } : { topTitle: 'English', url: 'https://customer.tac.com.tw/en/',openNewWeb: false }))
      _this.navTop = result
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/components/AppHeader.vue